'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';

import PcPreReservation from '@/features/quick-service-card/ui/PcPrereservation';
import QuickServiceCard, {
  CardTheme,
  IconType,
} from '@/features/quick-service-card/ui/PcQuickServiceCard';
import { VS_URL } from '@/shared/model/constants/url';
import PcAdaptiveLink, { LinkType } from '@/shared/ui/adaptiveLink/PcAdaptiveLink';
import Typography from '@/shared/ui/typogrphy/PcTypography';

interface QuickServiceItem {
  id: string;
  title: string;
  defaultTheme: CardTheme;
  hoverTheme: CardTheme;
  link: string;
  linkType: LinkType;
  defaultIconType: IconType;
  hoverIconType: IconType;
}

const quickServiceItems: QuickServiceItem[] = [
  {
    id: '1',
    title: 'card.items1.title',
    defaultTheme: 'lightBlue',
    hoverTheme: 'gradientBlue',
    link: '/visa-center/location#visa-center-h1',
    linkType: 'internal',
    defaultIconType: 'location',
    hoverIconType: 'locationLight',
  },
  {
    id: '2',
    title: 'card.items2.title',
    defaultTheme: 'lightBlue',
    hoverTheme: 'gradientBlue',
    link: VS_URL.VISA_APPLICATION_FORM,
    linkType: 'download',
    defaultIconType: 'asterisk',
    hoverIconType: 'asteriskLight',
  },
  {
    id: '3',
    title: 'card.items3.title',
    defaultTheme: 'lightBlue',
    hoverTheme: 'gradientBlue',
    link: 'https://www.visa.go.kr/openPage.do?MENU_ID=10101',
    linkType: 'external',
    defaultIconType: 'paperPlane',
    hoverIconType: 'paperPlaneLight',
  },
];

const PcQuickService = () => {
  const [hoveredId, setHoveredId] = useState<string | null>(null);
  const t = useTranslations('main.quick_service');
  return (
    <section className={'max-w-[1340px] px-[30px] mx-auto mt-[120px] mb-[230px]'}>
      {/*사전방문예약 hidden*/}
      {/*<div className={'mb-[120px]'}>*/}
      {/*  <PcPreReservation />*/}
      {/*</div>*/}
      <Typography variant={'category'}>Quick Service</Typography>
      <Typography variant={'heading'}>Korea Visa Center Link</Typography>
      <div className="flex flex-nowrap gap-[24px] mt-[64px] w-full">
        {quickServiceItems.map((item) => {
          const isHovered = hoveredId === item.id;
          const theme = isHovered ? item.hoverTheme : item.defaultTheme;
          const iconType = isHovered ? item.hoverIconType : item.defaultIconType;
          return (
            <div
              key={item.id}
              className="flex-1 min-w-0"
              onMouseEnter={() => setHoveredId(item.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              <PcAdaptiveLink href={item.link} type={item.linkType}>
                <QuickServiceCard
                  theme={theme}
                  title={t(item.title)}
                  // description={t(item.description)}
                  iconType={iconType}
                />
              </PcAdaptiveLink>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default PcQuickService;
